<template>
    <div class="flex flex-column gap-3">
        <div
            v-for="plan in plans"
            :key="plan.value"
            class="flex align-items-center gap-3 border-1 border-gray-200 border-round-lg p-3"
        >
            <Checkbox
                :modelValue="isPlanEnabled(plan.value)"
                :binary="true"
                @update:modelValue="togglePlan(plan.value, $event)"
            />
            <span class="font-medium text-gray-700 w-7rem">{{ plan.label }}</span>
            <InputNumber
                v-if="isPlanEnabled(plan.value)"
                :modelValue="getPlanPrice(plan.value)"
                @update:modelValue="setPlanPrice(plan.value, $event)"
                :min="0"
                :minFractionDigits="0"
                :maxFractionDigits="2"
                :locale="'da-DK'"
                placeholder="Price"
                class="flex-1"
            />
            <span v-else class="text-gray-400 text-sm flex-1">No custom price</span>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue'

const PLANS = [
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Biannual', value: 'Biannual' },
    { label: 'Annually', value: 'Annually' },
]

export default {
    props: ['context', 'field'],
    setup(props) {
        const plans = PLANS

        const configs = computed(() => props.context.subscriptionPriceConfigs ?? [])

        function isPlanEnabled(planValue) {
            return configs.value.some(c => c.subscriptionPlan === planValue)
        }

        function getPlanPrice(planValue) {
            const entry = configs.value.find(c => c.subscriptionPlan === planValue)
            return entry ? entry.price : null
        }

        function togglePlan(planValue, enabled) {
            const list = configs.value
            if (enabled) {
                if (!list.some(c => c.subscriptionPlan === planValue)) {
                    list.push({ subscriptionPlan: planValue, price: null })
                }
            } else {
                const idx = list.findIndex(c => c.subscriptionPlan === planValue)
                if (idx > -1) list.splice(idx, 1)
            }
        }

        function setPlanPrice(planValue, price) {
            const list = configs.value
            const idx = list.findIndex(c => c.subscriptionPlan === planValue)
            if (idx > -1) {
                list[idx].price = price
            }
        }

        return { plans, isPlanEnabled, getPlanPrice, togglePlan, setPlanPrice }
    },
}
</script>
